import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__check",
  "use": "icon__check-usage",
  "viewBox": "0 0 23.813 17.906",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 23.813 17.906\" id=\"icon__check\"><defs><style>#icon__check .cls-1{fill:#000;fill-rule:evenodd}</style></defs><path d=\"M8.985 17.892a.994.994 0 0 1-.698-.288l-8-7.954a.996.996 0 0 1-.006-1.406.991.991 0 0 1 1.403-.006l7.249 7.207L22.057.338a.99.99 0 0 1 1.399-.097.996.996 0 0 1 .096 1.403L9.733 17.55a.987.987 0 0 1-.711.341l-.037.001z\" class=\"cls-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol